The actual component value.
